export let dataForHeroSection={
  "attributes": {
    "mainHeadline": "Simplify Construction Management with EZELOGS",
    "highlightedWords": [
      {
        "word": "Construction Management",
        "color": "#4CAF50",
        "isBold": true
      },
      {
        "word": "EZELOGS",
        "color": "#2196F3",
        "isBold": false
      }
    ],
    "subtitle": "Manage Projects Seamlessly from Start to Finish",
    "description": "Ezelogs Construction Software sets a new benchmark for managing projects. From the initial stages to final closeout, Ezelogs streamlines workflows with tools built specifically for **construction professionals**.",
    "secondaryHeading": "Key Benefits of Using Ezelogs",
    "featurePoints": [
      {
        "id": 1,
        "text": "**Accounting & Financial Tools:** Handle budgets, invoices, and daily expenses effortlessly.",
        "icon": "calculator",
        "isActive": true
      },
      {
        "id": 2,
        "text": "**Effective Communication:** Manage team chats and streamline vendor collaboration.",
        "icon": "message-circle",
        "isActive": true
      },
      {
        "id": 3,
        "text": "**Resource Planning:** Monitor resources, address delays, and mitigate risks.",
        "icon": "calendar",
        "isActive": true
      },
      {
        "id": 4,
        "text": "**Safety and Compliance:** Generate safety reports, daily logs, and toolbox talk summaries.",
        "icon": "shield-check",
        "isActive": true
      },
      {
        "id": 5,
        "text": "**Performance Monitoring:** Track progress with cost-code-based and schedule-driven analytics.",
        "icon": "bar-chart",
        "isActive": true
      }
    ],
    "ctaButtons": {
      "primary": {
        "text": "Register for Your Free Trial",
        "link": "/register",
        "color": "#4CAF50",
        "textColor": "#FFFFFF",
        "isVisible": true,
        "openInNewTab": false
      },
      "secondary": {
        "text": "Request a Demo",
        "link": "/demo",
        "color": "#2196F3",
        "textColor": "#FFFFFF",
        "isVisible": true,
        "openInNewTab": false
      }
    },
    "heroImage": {
      "url": "/uploads/hero_dashboard_mockup.png",
      "alt": "EZELOGS Construction Management Dashboard",
      "width": 1200,
      "height": 800
    },
    "seoData": {
      "metaTitle": "Construction Management Software | EZELOGS",
      "metaDescription": "Simplify construction project management with EZELOGS. Manage projects seamlessly from start to finish with our comprehensive construction software."
    },
    "visibility": {
      "isPublished": true,
      "publishedAt": "2024-06-04T10:30:00.000Z",
      "scheduledPublish": null
    },
    "updatedAt": "2024-06-04T15:45:00.000Z",
    "createdAt": "2024-06-01T09:00:00.000Z"
  }
}
